import { render, staticRenderFns } from "./RuleTable.vue?vue&type=template&id=41e9dfbe&scoped=true&"
import script from "./RuleTable.vue?vue&type=script&lang=js&"
export * from "./RuleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e9dfbe",
  null
  
)

export default component.exports